export default __webpack_public_path__ + "static/media/word.492c1a0d.svg";